/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type HandleNotificationActionMutationVariables = Types.Exact<{
  notificationUserLinkId: Types.Scalars["NotificationUserLinkId"]["input"];
}>;

export type HandleNotificationActionMutation = {
  readonly __typename: "Mutation";
  readonly handleNotificationAction: {
    readonly __typename: "NotificationUserLink";
    readonly id: c.NotificationUserLinkId;
  };
};

export type NotificationRowFragment = {
  readonly __typename: "NotificationUserLink";
  readonly id: c.NotificationUserLinkId;
  readonly type: Types.InAppNotificationType;
  readonly contents: c.NotificationContents;
  readonly createdDate: c.DateTimeString;
  readonly status: Types.NotificationStatus;
  readonly fromUser: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly name: string | null;
    readonly email: string;
    readonly imageUrl: string | null;
  } | null;
};

export const NotificationRowFragmentDoc = /*#__PURE__*/ gql`
  fragment NotificationRowFragment on NotificationUserLink {
    id
    type
    contents
    createdDate
    status
    fromUser {
      id
      name
      email
      imageUrl
    }
  }
`;
export const HandleNotificationActionDocument = /*#__PURE__*/ gql`
  mutation HandleNotificationAction(
    $notificationUserLinkId: NotificationUserLinkId!
  ) {
    handleNotificationAction(notificationUserLinkId: $notificationUserLinkId) {
      id
    }
  }
`;
export type HandleNotificationActionMutationFn = Apollo.MutationFunction<
  HandleNotificationActionMutation,
  HandleNotificationActionMutationVariables
>;

/**
 * __useHandleNotificationActionMutation__
 *
 * To run a mutation, you first call `useHandleNotificationActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandleNotificationActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handleNotificationActionMutation, { data, loading, error }] = useHandleNotificationActionMutation({
 *   variables: {
 *      notificationUserLinkId: // value for 'notificationUserLinkId'
 *   },
 * });
 */
export function useHandleNotificationActionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    HandleNotificationActionMutation,
    HandleNotificationActionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    HandleNotificationActionMutation,
    HandleNotificationActionMutationVariables
  >(HandleNotificationActionDocument, options);
}
export type HandleNotificationActionMutationHookResult = ReturnType<
  typeof useHandleNotificationActionMutation
>;
export type HandleNotificationActionMutationResult =
  Apollo.MutationResult<HandleNotificationActionMutation>;
export type HandleNotificationActionMutationOptions =
  Apollo.BaseMutationOptions<
    HandleNotificationActionMutation,
    HandleNotificationActionMutationVariables
  >;
